import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { QueuesService } from '@app/_core/services/queues.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { timer,interval } from 'rxjs';
@Component({
  selector: 'app-session-timeout',
  templateUrl: './session-timeout.component.html',
  styleUrls: ['./session-timeout.component.scss'],
})
export class SessionTimeoutConfirmationComponent implements OnInit {
  defaultTime:any=120;
  interval: any;
  timeLeft: any=120;
  startTime: any;
  @Input() processGoingOn: boolean=false;
  constructor(
    public bsModalRef: BsModalRef,
    public queueService: QueuesService
  ) {
  }
  startTimer() {
    this.startTime=Date.now()+ this.defaultTime * 1000+2000;
    const timerSubscription=interval(1000).subscribe(()=>{
      this.timeLeft=Math.floor(((parseInt(this.startTime)-Date.now()))/1000);
      if(this.timeLeft<=0 && this.processGoingOn) 
      {
      this.processGoingOn=false;
       this.bsModalRef.hide();
       this.queueService.handlesSessionTimeout(true);
       timerSubscription.unsubscribe();
      }
    })
  }
  ngOnInit() {
    this.startTimer()
  }
  resetTimer()
  {
    this.processGoingOn=false;
    this.bsModalRef.hide();
    this.queueService.resetsSessionTimeout(true);
  }
}
